var select = {
  "select": {
    "maxWidth": "18.75rem",
    "position": "relative",
    "&::after": {
      "fontFamily": "\"dls-icons-2.25.0\"",
      "content": "\"\"",
      "lineHeight": "1",
      "WebkitFontSmoothing": "antialiased",
      "MozOsxFontSmoothing": "grayscale",
      "color": "#53565a",
      "fontSize": "1rem",
      "display": "flex",
      "alignItems": "center",
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "right": "0",
      "margin": "auto 0.5rem",
      "transition": "color 0.25S ease-out"
    }
  },
  "select_select": {
    "appearance": "none",
    "MozAppearance": "none",
    "WebkitAppearance": "none",
    "background": "transparent",
    "backgroundImage": "none",
    "border": "0.0625rem solid #c8c9c7",
    "borderRadius": "0.25rem",
    "transition": "border-color 0.25S ease-out",
    "cursor": "pointer",
    "fontSize": "1rem",
    "width": "100%",
    "zIndex": "1",
    "padding": "0.625rem",
    "textOverflow": "ellipsis",
    "paddingRight": "2rem",
    "&::-ms-expand": {
      "display": "none"
    },
    "&:active:not(.disabled)": {
      "outline": "dashed 1px #53565a",
      "outlineOffset": "3px",
      "borderColor": "#006fcf"
    },
    "&:focus:not(.disabled)": {
      "outline": "dashed 1px #53565a",
      "outlineOffset": "3px",
      "borderColor": "#006fcf"
    },
    "&:active:not(:disabled)": {
      "outline": "dashed 1px #53565a",
      "outlineOffset": "3px",
      "borderColor": "#006fcf"
    },
    "&:focus:not(:disabled)": {
      "outline": "dashed 1px #53565a",
      "outlineOffset": "3px",
      "borderColor": "#006fcf"
    },
    "&:disabled": {
      "outline": "none !important"
    },
    "&::-moz-focus-inner": {
      "border": "0",
      "outline": "none"
    },
    "&:-moz-focusring": {
      "color": "transparent",
      "textShadow": "0 0 0 #000"
    }
  },
  "select_disabled": {
    "color": "#c8c9c7",
    "&::after": {
      "color": "#c8c9c7"
    }
  },
  "select_formControl": {
    "display": "flex",
    "alignItems": "stretch",
    "alignContent": "stretch",
    "padding": "0",
    "border": "none"
  },
  "select_formControlSuccess": {
    "backgroundColor": "#f7f8f9",
    "backgroundImage": "none"
  },
  "select_formControlWarning": {
    "backgroundColor": "#f7f8f9",
    "backgroundImage": "none",
    "&::before": {
      "color": "#53565a"
    },
    "&::after": {
      "color": "#53565a"
    }
  },
  "select_formControlWarning_select": {
    "borderColor": "#b42c01",
    "&:focus": {
      "borderColor": "#b42c01"
    },
    "&:active": {
      "borderColor": "#b42c01"
    }
  },
  "selectIcon": {
    "height": "0.6875rem",
    "position": "absolute",
    "width": "1rem",
    "margin": "auto 0.5Em"
  },
  "selectIcon___select": {
    "paddingLeft": "1.875rem"
  },
  "hasWarning__select_formControl": {
    "backgroundColor": "#f7f8f9",
    "backgroundImage": "none",
    "&::before": {
      "color": "#53565a"
    },
    "&::after": {
      "color": "#53565a"
    }
  },
  "": {
    "&:-ms-fullscreen": {
      "height": "3.125rem",
      "alignItems": "center",
      "overflow": "visible"
    },
    "&:root .select:not(.selectTwoLined)": {
      "height": "3.125rem",
      "alignItems": "center",
      "overflow": "visible"
    }
  },
  "selectTwoLined_formControl": {
    "padding": "0"
  },
  "selectTwoLined_formControl_label": {
    "textAlign": "left",
    "width": "100%",
    "margin": "0",
    "padding": "0.625rem 2.5rem 0.625rem 0.625rem",
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap",
    "height": "4rem",
    "&:empty": {
      "height": "auto"
    },
    "&:empty + select": {
      "paddingTop": "0.625rem"
    }
  },
  "selectTwoLined_formControl_select": {
    "padding": "1.875rem 2.5rem 0.625rem 0.625rem",
    "height": "100%",
    "position": "absolute",
    "top": "0",
    "left": "0"
  }
};

export default select;
